<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/updatemapping")
          i.fas.fa-link
          span.ml-1 {{ $t("ui.change_date") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $tc("ui.leagues", 1) }}
                    DebounceInput(required type="text" v-model="leagueSearch" :placeholder="$t('message.search_by_league_name')")
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getLinkedMatchList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
        div.card-body
          div
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="linkedMatchTotalRow"
                  :per-page="getPageSize"
                  v-model="currentLinkedMatchPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize")
                  b-input(:value="linkedMatchTotalRow" readonly)
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 100%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(width=100 @click="sortOrder('match_id')")
                          span {{ $t('ui.id') }}
                          i(:class="changeSortKey('match_id')")
                        th.sticky-position(width=80 @click="sortOrder('sport_type')")
                          span {{ $tc('ui.sports', 1) }}
                          i(:class="changeSortKey('sport_type')")
                        th.sticky-position(@click="sortOrder('league_name')")
                          span {{ $tc("ui.leagues", 1) }}
                          i(:class="changeSortKey('league_name')")
                        th.sticky-position
                          span {{ $t("ui.home") }}
                        th.sticky-position
                          span {{ $t("ui.away") }}
                        th.sticky-position(width=60)
                          span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                        th.sticky-position(width=80 @click="sortOrder('match_date_time')")
                          span {{ $t("ui.short.match_date") }}
                          i(:class="changeSortKey('match_date_time')")
                        th.sticky-position(width=80)
                          span {{ $t("ui.short.match_time") }}
                        th.sticky-position(width=80)
                          span {{ $t("ui.sbo") }}
                        th.sticky-position(width=80)
                          span {{ $t("ui.ibc") }}
                        th.text-center.sticky-position(width=100)
                          span {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-if="linkedMatchList.length == 0")
                        td(colspan="11").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in linkedMatchList")
                        td
                          span {{ item.match_id }}
                        td
                          span {{ item.sport_type }}
                        td
                          span(:title="item.league_name") {{ item.league_name }}
                        td
                          span(:title="item.home_team") {{ item.home_team }}
                        td
                          span(:title="item.away_team") {{ item.away_team }}
                        td.text-uppercase
                          span {{ item.market_type }}
                        td
                          span {{ getDate(item.match_date) }}
                        td
                          span {{ item.match_time }}
                        td
                          span {{ item.sbo_map }}
                        td
                          span {{ item.ibc_map }}
                        td.actions
                          span
                            a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")

    matchmappinginfo(ref="matchMappingInfo" @failed="handleFailed" :info="matchInfo" @clicked="updateMatchMapping")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import matchmappinginfo from "@/components/match/matchMappingInfo.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    matchmappinginfo
  },
  data: () => ({
    loading: false,
    matchInfo: null,
    sportType: 1,
    sportList: [],
    linkedMatchList: [],
    currentLinkedMatchPage: 1,
    linkedMatchTotalRow: 0,
    leagueSearch: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    sortKey: "league_name",
    sortType: "asc",
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    }
  },
  mounted: function() {
    this.getSportList();
    this.startDate = this.yesterday;
    this.endDate = this.today;
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getLinkedMatchList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.updatemapping
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLinkedMatchList: function(isSearch) {
      let url = config.updateMatchMappingListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentLinkedMatchPage = 1;

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.updatemapping,
        sport_id: this.sportType,
        league_name: this.leagueSearch,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentLinkedMatchPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.linkedMatchList = response.data.tbl_match_update_mapping_list;
                this.linkedMatchTotalRow = this.linkedMatchList.length > 0 ? this.linkedMatchList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    onEdit(item) {
      this.matchInfo = item;
      this.$refs.matchMappingInfo.$refs.matchMappingInfoModal.show();
    },
    updateMatchMapping: function(matchId, sboMatch, ibcMatch) {
      this.linkedMatchList.filter(function(matchInfo) {
        if (matchInfo.match_id == matchId) {
          matchInfo.sbo_map = sboMatch;
          matchInfo.ibc_map = ibcMatch;
        }
      });
      this.$helpers.showDialog(this.$t("ui.update_mapping"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentLinkedMatchPage = 1;
      this.getLinkedMatchList();
    },
    changedPage: function(pageNo) {
      this.currentLinkedMatchPage = pageNo;
      this.getLinkedMatchList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>